<p-toast></p-toast>
<p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>

<div class="inline-block" #content (click)="toggle($event)">
  <ng-content></ng-content>
</div>